import './resource-show-main.css';
